<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Hoppá') }}!</h1>
        <p class="mb-16 text-center">{{ __('Ez az oldal nem található. Kérjük használd a fenti menüt.') }}</p>
        <span class="block text-9xl text-center">:-(</span>
    </div>
</template>
